<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">>在当订单 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>

      <div class="head_right">
        <span>在当订单：{{ len }}</span>
      </div>
    </div>
    <!-- 这是正文内容 -->
    <div class="contai_co">
      <!-- 数据统计栏 -->
      <div class="conta">
        <div class="con_box">
          <span class="con_text">今日订单:{{ dayorder }}</span>
        </div>
        <div class="con_bo">
          <span class="con_text">当前在当:{{ len }}</span>
        </div>
        <div class="con_b">
          <span class="con_text">在当金额:{{ price }}元</span>
        </div>
        <div class="con_bx">
          <span class="con_text">在当综合服务费:{{ pri }}元</span>
        </div>
      </div>
    </div>
    <!-- 这是列表栏 -->
    <div class="contai_li">
      <el-table :data="this.items" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="当户姓名：">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="联系电话"
                >:
                <span>{{ props.row.telephone }}</span>
              </el-form-item>
              <el-form-item label="典当物品"
                >:
                <span>{{ props.row.itemlb }}</span>
              </el-form-item>
              <el-form-item :label="props.row.nf"
                >:
                <span>{{ props.row.attrsx }}</span>
              </el-form-item>
              <el-form-item :label="props.row.zl"
                >:
                <span>{{ props.row.typezl }}</span>
              </el-form-item>
              <el-form-item :label="props.row.weight"
                >:
                <span>{{ props.row.itemattsx }}</span>
              </el-form-item>
              <el-form-item label="典当周期"
                >:
                <span>{{ props.row.mode }}天</span>
              </el-form-item>
              <el-form-item label="典当价格"
                >:
                <span>{{ props.row.price }}元</span>
              </el-form-item>
              <el-form-item label="开始日期"
                >:
                <span>{{ props.row.date }}</span>
              </el-form-item>
              <el-form-item label="结束日期"
                >:
                <span>{{ props.row.preFinishedDate }}</span>
              </el-form-item>
              <el-form-item label="鉴定方式"
                >:
                <span>{{ props.row.mod }}</span>
              </el-form-item>
              <el-form-item label="当品描述"
                >:
                <span>{{ props.row.descrms }}</span>
              </el-form-item>
              <el-form-item label="典当状态"
                >:
                <span>{{ props.row.state }}</span>
              </el-form-item>
              <el-form-item label="收货地址"
                >:
                <span>{{ props.row.sfdz }}</span>
              </el-form-item>
              <el-form-item label="收款开户行"
                >:
                <span>{{ props.row.userinfo }}</span>
              </el-form-item>
              <el-form-item label="收款银行账号"
                >:
                <span>{{ props.row.userbank }}</span>
              </el-form-item>
              <el-form-item label="证件号码"
                >:
                <span>{{ props.row.idcard }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="当户" prop="name"> </el-table-column>
        <el-table-column
          prop="date"
          label="开始日期"
          sortable
          column-key="date"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column label="结束日期" prop="preFinishedDate"> </el-table-column>
        <el-table-column label="典当物品" prop="itemlb"> </el-table-column>
        <el-table-column label="典当状态" prop="state"> </el-table-column>
        <el-table-column label="典当金额" prop="price"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "when",
  data() {
    return {
      ACCESS_TOKEN: "", //get请求的ACCESS_TOKEN密钥
      items: [], //请求回来所有在当的数据
      deta: "", //当前的日期
      len: 0, //所有订单的总数量
      dayorder: 0, //今日的订单数量
      price: 0, //金额
      pri: 0, //已收利息的总金额
    };
  },
  methods: {
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("date");
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },


  },
  created() {
    //获取到当前的日期
    this.deta = dayjs().format("YYYY-MM-DD ddd");
    //获取ACCESS_TOKEN
    this.getTokens()

    //获取当前登录信息
    this.getUserToken()


  },

  //

  mounted() {

    setTimeout(()=>{
          //  post请求获取数据
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("user_ddxx").where({state:"在当"}).get()',
      })
      .then((aa) => {
        if (aa.data.errcode == 0) {
          aa.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = aa.data.data;
          this.len = aa.data.data.length;

          //循环计算在当的总金额
          let str = "";
          for (let i in this.items) {
            str += this.items[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.price = eval(str);

          //循环计算当户已支付的总金额
          let zpri = "";
          for (let a in this.items) {
            zpri += this.items[a].ddzh;
            zpri += "+";
          }
          zpri = zpri.substring(0, zpri.length - 1);
          this.pri = eval(zpri);

          //过滤筛选日期等于今天订单
          let products = this.items.filter(function (product) {
            return product.date === dayjs().format("YYYY-MM-DD");
          });
          this.dayorder = products.length;
        } else {
             this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
        }
      });

    },800)
   
    
   
  },
};
</script>
<style scoped>
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}
.haed_cont {
  font-size: 20px;
}
.head_right {
  margin: 13px 50px;
  font-size: 20px;
}
.contai_co {
  width: 100%;
  height: 150px;
  background-color: #ffffff;
  margin: 10px auto;
  border-radius: 10px;
}
.conta {
  width: 95%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
}
.con_box {
  width: 350px;
  height: 120px;
  background-color: #a9d463;
  border-radius: 15px;
  margin: 16px auto;
}
.con_text {
  color: #ffffff;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 37px 0;
}
.con_bo {
  width: 350px;
  height: 120px;
  background-color: #639dd4;
  border-radius: 15px;
  margin: 16px auto;
}
.con_b {
  width: 350px;
  height: 120px;
  background-color: #d3687f;
  border-radius: 15px;
  margin: 16px auto;
}
.con_bx {
  width: 350px;
  height: 120px;
  background-color: #d3b668;
  border-radius: 15px;
  margin: 16px auto;
}
.contai_li {
  width: 100%;
  background-color: #ffffff;
  /* border-radius: 15px; */
}
/*列表样式 */
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 25%;
}
</style>
